module.exports = __webpack_public_path__ + "static/img/about_banner.f88f026.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus/about_banner.png
// module id = p4Oa
// module chunks = 44